export function formatAgentCode(code) {
  if (!code) return "—";
  const num = Number(code);
  if (isNaN(num)) return String(code);
  if (num < 1000) {
    return `1000${num}`;
  }
  return String(num);
}